// Puantaj Kayıtları — manuel snapshot yetkisi (yalnızca super_admin veya admin impersonation).

import { CLIENT_ROLES } from "@routebot/constants";

/** Admin panelinden kullanıcı taklidi (impersonation) aktif mi? */
export function isAdminImpersonationSession() {
  try {
    return localStorage.getItem("isImpersonating") === "true" && !!localStorage.getItem("adminClientData");
  } catch {
    return false;
  }
}

/** Manuel "Snapshot al" UI/API yetkisi. Normal şirket kullanıcıları false döner. */
export function canRunWorklogSnapshot(auth) {
  if (isAdminImpersonationSession()) return true;
  return auth?.client?.role === CLIENT_ROLES.SUPER_ADMIN;
}
